import type { JSX } from "preact";
import styles from "./icon.module.css";

/** Line icons on a 24-unit square, stroked in the text colour. */
const PATHS = {
  lock: (
    <>
      <rect x="5" y="10" width="14" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" />
    </>
  ),
  grab: <path d="M4 19h16M12 16V5M8 9l4-4 4 4" />,
  push: <path d="M12 3v8M8 7l4 4 4-4M3 19c3 0 5-4 9-4s6 4 9 4" />,
  inflate: <path d="M3 20c2 0 4-8 9-8s7 8 9 8M12 3v6M9 6h6" />,
  smooth: <path d="M3 10c2-2 4-2 6 0s4 2 6 0 4-2 6 0M3 17h18" />,
  flatten: <path d="M3 19h18M6 14h12M12 14V5" />,
  mirror: (
    <>
      <path d="M12 3v18" stroke-dasharray="2 3" />
      <path d="M9 7l-5 5 5 5M15 7l5 5-5 5" />
    </>
  ),
  wheel: (
    <>
      <ellipse cx="12" cy="18" rx="9" ry="3" />
      <path d="M9 15c-1-3 0-6 1-8h4c1 2 2 5 1 8M16 4.5a7 7 0 0 1 3.5 2.5M19.5 7l.3-2.8M19.5 7l-2.8-.2" />
    </>
  ),
  undo: <path d="M9 14 4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11" />,
  home: <path d="M4 11.5 12 5l8 6.5M6.5 10v9.5h4v-5h3v5h4V10" />,
  restart: <path d="M4 12a8 8 0 1 0 2.5-5.8M4 4v5h5" />,
  help: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9.5a2.5 2.5 0 1 1 3.4 2.3c-.6.3-.9.8-.9 1.4v.3M12 16.8v.2" />
    </>
  ),
  settings: (
    <>
      <path d="M4 6h9M19 6h1M4 12h3M13 12h7M4 18h11M21 18h-1" />
      <circle cx="16" cy="6" r="2.5" />
      <circle cx="10" cy="12" r="2.5" />
      <circle cx="18" cy="18" r="2.5" />
    </>
  ),
  medal: (
    <>
      <circle cx="12" cy="9" r="5.5" />
      <path d="M9 14 7.5 21l4.5-2.5 4.5 2.5L15 14" />
    </>
  ),
  sound: <path d="M4 9.5h3.5L12 6v12l-4.5-3.5H4zM15.5 9.5a3.5 3.5 0 0 1 0 5M18 7a7 7 0 0 1 0 10" />,
  paw: (
    <g fill="currentColor" stroke="none">
      <ellipse cx="12" cy="16" rx="5" ry="4" />
      <ellipse cx="5.5" cy="10.5" rx="2" ry="2.5" />
      <ellipse cx="9.5" cy="6.5" rx="2" ry="2.5" />
      <ellipse cx="14.5" cy="6.5" rx="2" ry="2.5" />
      <ellipse cx="18.5" cy="10.5" rx="2" ry="2.5" />
    </g>
  ),
} satisfies Record<string, JSX.Element>;

export type IconName = keyof typeof PATHS;

export function Icon({ name, class: extra }: { name: IconName; class?: string }) {
  return (
    <svg
      class={extra ? `${styles.icon} ${extra}` : styles.icon}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      {PATHS[name]}
    </svg>
  );
}
